/* tslint:disable */
/* eslint-disable */

import { ConcreteRequest } from "relay-runtime";
export type PipelineQueryVariables = {};
export type PipelineQueryResponse = {
    readonly searchOrders: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly status: string;
        readonly videoDownloadStatus: string;
        readonly videoTransferStatus: string | null;
        readonly cardVideoURL: string | null;
        readonly cardVideoSHA256: string | null;
        readonly shopify: {
            readonly videoManifest: ReadonlyArray<string> | null;
            readonly lineItems: ReadonlyArray<{
                readonly SKU: string;
                readonly quantity: number;
            }> | null;
        } | null;
        readonly cardVideoEncodedConfig: {
            readonly vertical: boolean;
            readonly allowVertical: boolean;
        } | null;
        readonly balanceUsages: ReadonlyArray<{
            readonly id: string;
            readonly vendorSaleVendorId: string | null;
            readonly vendorSaleId: string | null;
        }> | null;
        readonly designs: ReadonlyArray<{
            readonly destinations: ReadonlyArray<{
                readonly albumDesign: {
                    readonly id: string;
                    readonly pages: ReadonlyArray<{
                        readonly pageNumber: number;
                        readonly cardVideoURL: string | null;
                        readonly cardVideoSHA256: string | null;
                        readonly designId: string | null;
                    }>;
                } | null;
            }> | null;
        }> | null;
    }>;
    readonly devices: ReadonlyArray<{
        readonly id: string;
        readonly status: string;
        readonly videoTransferStatus: string | null;
        readonly transferredOrderId: string | null;
        readonly allowBlank: boolean | null;
    } | null>;
};
export type PipelineQuery = {
    readonly response: PipelineQueryResponse;
    readonly variables: PipelineQueryVariables;
};



/*
query PipelineQuery {
  searchOrders(query: "", destinationsBecomeOrders: true) {
    id
    name
    status
    cardVideoURL
    cardVideoSHA256
    shopify {
      videoManifest
      lineItems {
        SKU
        quantity
      }
    }
    cardVideoEncodedConfig {
      vertical
      allowVertical
    }
    balanceUsages {
      id
      vendorSaleVendorId
      vendorSaleId
    }
    designs {
      destinations {
        albumDesign {
          id
          pages {
            pageNumber
            cardVideoURL
            cardVideoSHA256
            designId
            id
          }
        }
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "destinationsBecomeOrders",
    "value": true
  },
  {
    "kind": "Literal",
    "name": "query",
    "value": ""
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardVideoURL",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardVideoSHA256",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ShopifyOrder",
  "kind": "LinkedField",
  "name": "shopify",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoManifest",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShopifyLineItem",
      "kind": "LinkedField",
      "name": "lineItems",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "SKU",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantity",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "VideoConfiguration",
  "kind": "LinkedField",
  "name": "cardVideoEncodedConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowVertical",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "BalanceUsage",
  "kind": "LinkedField",
  "name": "balanceUsages",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vendorSaleVendorId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vendorSaleId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageNumber",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "designId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoTransferStatus",
  "storageKey": null
},
v12 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "videoDownloadStatus",
      "storageKey": null
    },
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Device",
      "kind": "LinkedField",
      "name": "devices",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v3/*: any*/),
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transferredOrderId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBlank",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "searchOrders",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithDestinations",
            "kind": "LinkedField",
            "name": "designs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Destination",
                "kind": "LinkedField",
                "name": "destinations",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AlbumDesign",
                    "kind": "LinkedField",
                    "name": "albumDesign",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AlbumPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": "searchOrders(destinationsBecomeOrders:true,query:\"\")"
      },
      (v13/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PipelineQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "searchOrders",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DesignWithDestinations",
            "kind": "LinkedField",
            "name": "designs",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Destination",
                "kind": "LinkedField",
                "name": "destinations",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AlbumDesign",
                    "kind": "LinkedField",
                    "name": "albumDesign",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AlbumPage",
                        "kind": "LinkedField",
                        "name": "pages",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v10/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": "searchOrders(destinationsBecomeOrders:true,query:\"\")"
      },
      (v13/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7d8943bd4c95bd01c649e2045428654e",
    "id": null,
    "metadata": {},
    "name": "PipelineQuery",
    "operationKind": "query",
    "text": "query PipelineQuery {\n  searchOrders(query: \"\", destinationsBecomeOrders: true) {\n    id\n    name\n    status\n    cardVideoURL\n    cardVideoSHA256\n    shopify {\n      videoManifest\n      lineItems {\n        SKU\n        quantity\n      }\n    }\n    cardVideoEncodedConfig {\n      vertical\n      allowVertical\n    }\n    balanceUsages {\n      id\n      vendorSaleVendorId\n      vendorSaleId\n    }\n    designs {\n      destinations {\n        albumDesign {\n          id\n          pages {\n            pageNumber\n            cardVideoURL\n            cardVideoSHA256\n            designId\n            id\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '095a682636595fcc9f5ae3e290dd3d29';
export default node;
